var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.54,
    height: 20.78,
    viewBox: "0 0 27.54 20.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19866",
    "data-name": "Group 19866",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31692",
    "data-name": "Path 31692",
    d: "M25.35,22.9a1.69,1.69,0,0,1-1.69,1.69H3.38A1.69,1.69,0,0,1,1.69,22.9V12.76a1.69,1.69,0,0,1,1.69-1.69H5.361A5.07,5.07,0,0,0,8.943,9.584l1.4-1.4a1.69,1.69,0,0,1,1.191-.5H15.5a1.69,1.69,0,0,1,1.195.495l1.4,1.4a5.07,5.07,0,0,0,3.586,1.485H23.66a1.69,1.69,0,0,1,1.69,1.69ZM3.38,9.38A3.38,3.38,0,0,0,0,12.76V22.9a3.38,3.38,0,0,0,3.38,3.38H23.66a3.38,3.38,0,0,0,3.38-3.38V12.76a3.38,3.38,0,0,0-3.38-3.38H21.679a3.38,3.38,0,0,1-2.389-.99l-1.4-1.4A3.38,3.38,0,0,0,15.5,6H11.539a3.38,3.38,0,0,0-2.389.99l-1.4,1.4a3.38,3.38,0,0,1-2.39.99Z",
    transform: "translate(0 -6)",
    fill: "#6b6b6b",
    stroke: "#6b6b6b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31693",
    "data-name": "Path 31693",
    d: "M16.14,25.14a4.225,4.225,0,1,1,4.225-4.225A4.225,4.225,0,0,1,16.14,25.14Zm0,1.69a5.915,5.915,0,1,0-5.915-5.915A5.915,5.915,0,0,0,16.14,26.83ZM7.69,17.535a.845.845,0,1,1-.845-.845A.845.845,0,0,1,7.69,17.535Z",
    transform: "translate(-2.62 -9.93)",
    fill: "#6b6b6b",
    stroke: "#6b6b6b",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5421c6c691d8daf9b87dcab56f7d90a4.svg";
export { ForwardRef as ReactComponent };